<span class="pill-state-button" [class.succeed]="state" [class.disabled]="disabled" [tooltip]="state ? tooltip : negativeTooltip" (click)="toggleState()">
  <span><svg-icon [key]="state ? icon : negativeIcon" /> {{ state ? text : (negativeText ?? text) }}</span>
</span>
